import React from 'react';
import classnames from 'classnames';
import * as R from 'ramda';
import { ColumnTree } from '../hooks/useTable/defineColumns';

export const LocationsColumn = ColumnTree.defineNode('locations', {
  predicate({ solutionColumns }) {
    return 'locations' in solutionColumns && solutionColumns.locations
      ? true
      : false;
  },
  make({ solutionColumns, sortDirection, sortColumn, setSort }) {
    return {
      title: (
        <div>
          <a
            href="#locations"
            className={classnames('icon-sort', 'sortem', {
              [sortDirection]: sortColumn === 'locations',
            })}
            onClick={() => setSort('locations')}
          >
            {R.propOr('Location', 'label', solutionColumns.locations)}
          </a>
        </div>
      ),
      key: 'locations',
      className: 'col-locations',
      render: (text, record) => (
        <div className="td-content">
          <span className="truncate-text">
            {(record.locations ?? []).map((item) => item.name).join(', ')}
          </span>
        </div>
      ),
    };
  },
});
